import { render, staticRenderFns } from "./InsightDetailsPopup.vue?vue&type=template&id=647818ab"
import script from "./InsightDetailsPopup.vue?vue&type=script&lang=js"
export * from "./InsightDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./InsightDetailsPopup.vue?vue&type=style&index=0&id=647818ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports